import ValidationType from '../ValidationType';

class DoesNotContainValueCaseSensitive extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    const errors = [];
    const compareValue = validation.value || '';
    const currentValue = fieldResponse.currentValue || '';

    // Attempt to find the compare value within the current value
    if (currentValue && currentValue.includes(compareValue)) {
      const error = this.createValidationError({
        fieldResponse,
        key: 'ERROR_DOES_NOT_CONTAIN_VALUE_CASE_SENSITIVE',
        values: { value: compareValue },
        message: `Value should not contain '${compareValue}' (case sensitive)`,
      });
      errors.push(error);
    }
    return errors;
  }
}

export default DoesNotContainValueCaseSensitive;
